if (!customElements.get('made-in')) {
  customElements.define(
    'made-in',
    class MadeIn extends HTMLElement {
      connectedCallback() {
        this.setupListeners();
      }

      setupListeners() {
        // Query modal trigger button
        this.modalTriggerEl = document.querySelector(
          '[data-made-in-external-el="modal-trigger"]',
        );

        if (!this.modalTriggerEl) {
          console.warn('Modal trigger not found');
          return;
        }

        // Modal close elements (inside component)
        this.modalCloseEls = this.querySelectorAll('[data-made-in-el="modal-close"]');

        // Bind handlers
        this.handleModalTrigger = this.handleModalTrigger.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);

        // Add listeners
        this.modalTriggerEl.addEventListener('click', this.handleModalTrigger);

        this.modalCloseEls.forEach((el) => {
          el.addEventListener('click', this.handleModalClose);
        });

      }

      handleModalTrigger(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setAttribute('aria-hidden', 'false');
      }

      handleModalClose(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setAttribute('aria-hidden', 'true');
      }
    },
  );
}